import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5d0fdc87")

_pushScopeId("data-v-5d0fdc87")
const _hoisted_1 = { class: "relative flex w-full mt-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["flex w-full overflow-x-auto", _ctx.hideScroll ? 'hide-scroll' : ''],
      ref: "horizontalScrollContainer",
      onScrollPassive: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 34),
    (!_ctx.hideToggle && _ctx.scrollPercent > 0)
      ? (_openBlock(), _createBlock("img", {
          key: 0,
          src: require(`@/app/ui/assets/svg/prev-arrow-red.svg`),
          style: [_ctx.leftScrollIconStyle, {"top":"34%","transform":"translateY(-34%)"}],
          class: "w-8 absolute cursor-pointer left-0",
          onClick: _cache[2] || (_cache[2] = () => _ctx.onToggleSlide(_ctx.$refs, 'right')),
          alt: "right"
        }, null, 12, ["src"]))
      : _createCommentVNode("", true),
    (!_ctx.hideToggle && _ctx.scrollPercent < 100)
      ? (_openBlock(), _createBlock("img", {
          key: 1,
          src: require(`@/app/ui/assets/svg/next-arrow-red.svg`),
          style: [_ctx.rightScrollIconStyle, {"top":"34%","right":"-1rem","transform":"translateY(-34%)"}],
          class: "w-8 absolute cursor-pointer",
          onClick: _cache[3] || (_cache[3] = () => _ctx.onToggleSlide(_ctx.$refs, 'left')),
          alt: "left"
        }, null, 12, ["src"]))
      : _createCommentVNode("", true)
  ]))
})